import { ParsedUrlQuery } from 'querystring';
import React, { useEffect } from 'react';
import { SwitchTemplate } from '@catalogo/core-switch-template';
import { localStorage } from '@catalogo/core-local-storage';

export interface ComponentProps {
  routeId: string;
  parsedQs: ParsedUrlQuery;
  match: {
    params: {
      term: string;
    };
  };
}

type RecentSearch = {
  term: string;
  id: number;
  rc?: string | string[];
};

export const Search: React.FC<ComponentProps> = props => {
  const { parsedQs, match } = props;
  const rc = parsedQs?.rc;
  const term = match?.params?.term;

  useEffect(() => {
    if (term) {
      const recentSearches: RecentSearch[] = localStorage.get('recentSearches');
      const filteredTerms = recentSearches.filter(item => item.term !== term);

      filteredTerms.push({ term, id: Date.now(), rc });
      localStorage.setItem('recentSearches', filteredTerms);
    }
  });

  return <SwitchTemplate component="search" {...props} />;
};

export default Search;
